const actions = {
  GET_TABLES_AND_RESERVATIONS_PER_REGION_REQUEST:
    "GET_TABLES_AND_RESERVATIONS_PER_REGION_REQUEST",
  GET_TABLES_AND_RESERVATIONS_PER_REGION_SUCCESS:
    "GET_TABLES_AND_RESERVATIONS_PER_REGION_SUCCESS",

  GET_RESERVATIONS_PER_REGION_REQUEST: "GET_RESERVATIONS_PER_REGION_REQUEST",
  GET_RESERVATIONS_PER_REGION_SUCCESS: "GET_RESERVATIONS_PER_REGION_SUCCESS",

  CREATE_RESERVATIONS_GET_TABLES_REQUEST:
    "CREATE_RESERVATIONS_GET_TABLES_REQUEST",
  CREATE_RESERVATIONS_GET_TABLES_SUCCESS:
    "CREATE_RESERVATIONS_GET_TABLES_SUCCESS",

  CREATE_RESERVATIONS_REQUEST: "CREATE_RESERVATIONS_REQUEST",
  CREATE_RESERVATIONS_SUCCESS: "CREATE_RESERVATIONS_SUCCESS",
  EDIT_RESERVATIONS_REQUEST: "EDIT_RESERVATIONS_REQUEST",
  EDIT_RESERVATIONS_SUCCESS: "EDIT_RESERVATIONS_SUCCESS",
  DELETE_RESERVATIONS_REQUEST: "DELETE_RESERVATIONS_REQUEST",
  DELETE_RESERVATIONS_SUCCESS: "DELETE_RESERVATIONS_SUCCESS",

  OPEN_RESERVATION_EDIT_MODAL: "OPEN_RESERVATION_EDIT_MODAL",
  CLOSE_RESERVATION_EDIT_MODAL: "CLOSE_RESERVATION_EDIT_MODAL",
  OPEN_RESERVATION_CREATE_MODAL: "OPEN_RESERVATION_CREATE_MODAL",
  CLOSE_RESERVATION_CREATE_MODAL: "CLOSE_RESERVATION_CREATE_MODAL",

  CREATE_RESERVATIONS_CLIENT_HISTORY_REQUEST:
    "CREATE_RESERVATIONS_CLIENT_HISTORY_REQUEST",
  CREATE_RESERVATIONS_CLIENT_HISTORY_SUCCESS:
    "CREATE_RESERVATIONS_CLIENT_HISTORY_SUCCESS",

  getTablesAndReservationPerRegion: (getReservationsData) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TABLES_AND_RESERVATIONS_PER_REGION_REQUEST,
        getReservationsData,
      });
    };
  },

  getReservationsPerRegion: (getReservationsData) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_RESERVATIONS_PER_REGION_REQUEST,
        getReservationsData,
      });
    };
  },

  createReservationGetTables: (reservationTablesData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_RESERVATIONS_GET_TABLES_REQUEST,
        reservationTablesData,
      });
    };
  },

  createReservation: (createReservationData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_RESERVATIONS_REQUEST,
        createReservationData,
      });
    };
  },

  editReservation: (editReservationData) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_RESERVATIONS_REQUEST,
        editReservationData,
      });
    };
  },

  deleteReservation: (reservationId) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_RESERVATIONS_REQUEST,
        reservationId,
      });
    };
  },

  createReservationClientHistory: (createReservationClientHistoryData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_RESERVATIONS_CLIENT_HISTORY_REQUEST,
        createReservationClientHistoryData,
      });
    };
  },
};

export default actions;
